import React from 'react';
import { MinusIcon, PlusIcon } from '@rsos/assets/icons';
import { Box, Text } from '@rsos/base-components';
import {
  Container,
  Header,
  Dropdown,
  ToggleButton,
  Content,
} from './TimeSlider.styles';
import type { Sublayer } from './TimeSlider.types';

interface TimeSliderContainerProps {
  timeEnabledLayers: Sublayer[];
  isExpanded: boolean;
  selectedLayerId: string | null;
  onLayerChange: (layerId: string) => void;
  onToggle: () => void;
  children: React.ReactNode;
}

export const TimeSliderContainer = React.forwardRef<
  HTMLDivElement,
  TimeSliderContainerProps
>(
  (
    {
      timeEnabledLayers,
      isExpanded,
      selectedLayerId,
      onLayerChange,
      onToggle,
      children,
    },
    ref,
  ) => {
    const handleDropdownChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
      onLayerChange(e.target.value);
    };

    return (
      <Container ref={ref}>
        <Header horizontal>
          <Box horizontal align="center">
            <Box mr={2}>
              <Text size="small" color="primaryText" fontWeight="bold">
                Time Filter:
              </Text>
            </Box>
            <Dropdown
              value={selectedLayerId || ''}
              onChange={handleDropdownChange}
            >
              {timeEnabledLayers.map(sublayer => (
                <option key={sublayer.sublayerID} value={sublayer.sublayerID}>
                  {`${sublayer.display_name} - ${sublayer.sublayerName}` ||
                    sublayer.display_name ||
                    `Layer ${sublayer.sublayerID}`}
                </option>
              ))}
            </Dropdown>
          </Box>
          <ToggleButton onClick={onToggle}>
            {isExpanded ? <MinusIcon /> : <PlusIcon />}
          </ToggleButton>
        </Header>
        <Content $isExpanded={isExpanded}>{children}</Content>
      </Container>
    );
  },
);

TimeSliderContainer.displayName = 'TimeSliderContainer';
